import React from "react"

interface DataItemProps {
  label?: string
  value: any
  last?: boolean
  isCentered?: boolean
}

const DataItem = ({ label, value, last, isCentered }: DataItemProps) => {
  const isEmpty =
    value === null ||
    value === undefined ||
    value === "" ||
    (typeof value === "object" && Object.keys(value).length === 0)

  return (
    <div
      className={`flex flex-row ${isCentered ? "justify-center" : "justify-between"} items-center py-3 px-4 ${!last ? "border-b border-gray-100" : ""}`}
    >
      {label && <p className="text-[13px] font-medium text-gray-500 uppercase tracking-tight">{label}</p>}
      <p
        className={`text-[14px] font-bold ${!isCentered ? "text-right" : "text-center"} max-w-[60%] break-all ${isEmpty ? "text-gray-300 italic" : "text-gray-700"}`}
      >
        {isEmpty ? "[Vacío]" : typeof value === "object" ? JSON.stringify(value) : String(value)}
      </p>
    </div>
  )
}

export default DataItem
